import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_OFFICERS = gql`
    query barangayOfficers($barangay_uid: String, $barangay_term_uid: String, $searchFilter: SearchParams) {
		barangayOfficers(barangay_uid: $barangay_uid, barangay_term_uid: $barangay_term_uid, searchFilter: $searchFilter)
    }
`

const Officers = (props) => {
	const { 
		client, barangay_uid, barangay_term_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_OFFICERS}
			variables={{
				barangay_uid,
				barangay_term_uid,
				searchFilter: { page: 1, pageSize: 50, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const officers = _.has(data, 'barangayOfficers') ? data.barangayOfficers.data : []
				//console.log('purok', purok)
				return (
					<Select 
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Officer'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mOfficer = _.find(officers, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mOfficer)
							}
							onChange(value)
						}}
						{ ...rest }
					>
						{
							officers.map((item, key) => (
								<Option key={key} value={item.uid}>
									{`${item.full_name} (${item.position_name})`}
								</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(Officers)